import type { DocumentId, DocumentRevision, IssueStatusType, UserId } from 'core/types';

export type IssueLinkModel = {
  entityType: string;
  entityID: DocumentId;
};
export class IssueModel {
  _id: DocumentId;

  _rev: DocumentRevision;

  title: string;

  description: string;

  assigneeIDs: UserId[];

  status: IssueStatusType;

  dueDate: Date;

  link: IssueLinkModel;

  createdAtUTC?: Date;

  createdBy: UserId;
}
